import { render, staticRenderFns } from "./selectapi.vue?vue&type=template&id=04f928f6&scoped=true&"
import script from "./selectapi.vue?vue&type=script&lang=js&"
export * from "./selectapi.vue?vue&type=script&lang=js&"
import style0 from "./selectapi.vue?vue&type=style&index=0&id=04f928f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f928f6",
  null
  
)

export default component.exports